import React, { useCallback, useMemo } from 'react'
import { ListarInformacoesTelaInfoPNota } from '../../../services/api'
import FiltroTabelas from './components/TabelaInfoPNota'
import { HeadingPages } from '../../../components/HeadingPages'
import { Filtro } from './components/Filtro'

function InfoPNota() {
  const [dados, setDados] = React.useState([])
  const [loading, setLoading] = React.useState(false)

  const buscarInfoPorNota = useCallback(async (filter) => {
    try {
      const params = {
        codigo_parceiro: filter.codParc,
        numero_pedido: filter.pedido,
        data_entrada: filter.dataDe,
        data_saida: filter.dataAte,
        pendente: filter.pendente,
        nfe: filter.nfe,
      }

      setLoading(true)

      const response = await ListarInformacoesTelaInfoPNota.post('', params)
      var dados = []
      var data = response.data

      data.map((data) => {
        var preco_home = Math.round(parseFloat(data.valor_nota) * 100) / 100
        if (isNaN(preco_home)) {
          preco_home = 0.0
        }

        dados.push({
          ...data,
          cod_parc: data.cod_parc,
          data_pronto: data.data_pronto,
          data_saida: data.data_saida,
          nome_parc: data.nome_parc,
          nome_vendedor: data.nome_vendedor,
          numero_pedido: data.numero_pedido,
          numero_unico: data.numero_nota,
          peso_total: data.peso_total,
          peso_real: data.peso_real,
          quantidades_caixa: data.quantidades_caixa,
          numero_unico_origem: data.numero_unico_origem,
          status_pendencia: data.status_pendencia,
          data_finalizacao: data.data_finalizacao,
          valor_nota: (Math.round(parseFloat(preco_home) * 100) / 100).toLocaleString('pt-br', {
            minimumFractionDigits: 2,
          }),
          existe_remessa: data.existe_remessa,
          razao_social: data.razao_social,
          transportadora: data.transportadora,
          nunota_org: data.nunota_org,
          codigo_produto: data.codigo_produto,
          sequencia: data.sequencia,
          data_emissao_nota: data.data_emissao_nota,
          nota_antecipada: data.nota_antecipada,
          link_layout: data.link_layout,
          valida_st: data.vailida_st,
          valida_nf: data.valida_nf,
          nf_liberada: data.nf_liberada,
        })
      })

      const dataSemDuplicados = dados.filter((item, index, self) => {
        return index === self.findIndex((t) => t.numero_pedido === item.numero_pedido)
      })

      //138611
      setDados(dataSemDuplicados)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(Object.keys(error), error.message)
    }
  }, [])

  const dadosMemo = useMemo(() => {
    return dados
  }, [dados])

  React.useEffect(() => {
    buscarInfoPorNota({
      codParc: '',
      pedido: '',
      dataDe: '',
      dataAte: '',
      pendente: '',
      nfe: '',
    })
  }, [buscarInfoPorNota])

  return (
    <>
      <HeadingPages name={'EMISSÃO DE NOTA'} />
      <Filtro resultado={buscarInfoPorNota} />

      <FiltroTabelas view_loading_update={loading} resultado={buscarInfoPorNota} dados={dadosMemo} />
    </>
  )
}

export default InfoPNota
